import { Card, CardBody } from "reactstrap";
import { Badges, H6, Image, P, Ribbon } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { RightSidebarCardsData } from "../../../../../Data/Miscellaneous/JobSearch";
import { RightSidebarCardProps } from "../../../../../Types/MiscellaneousType";
import { dynamicImage } from "../../../../../Utils";
import PaginationCard from "./PaginationCard";
import { Rating } from "react-simple-star-rating";

const RightSidebarCards: React.FC<RightSidebarCardProps> = ({ startLimit,endLimit, colClass ,pagination}) => {
  return (
    <>
      {RightSidebarCardsData.slice(startLimit, endLimit).map((item, i) => (
        <div className={colClass} key={i}>
          <Card className={item.ribbon ? "ribbon-vertical-left-wrapper" : ""}>
            {item.ribbon && (
              <Ribbon className="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary">
                <i className="icofont icofont-love"></i>
              </Ribbon>
            )}
            <div className="job-search">
              <CardBody>
                <div className="d-flex">
                  <Image className="img-40 img-fluid m-r-20" src={dynamicImage(`job-search/${item.logo}`)} alt="" />
                  <div className="flex-grow-1">
                    <H6 className="f-w-600">
                      <a href={Href}>{item.job_name}</a>
                      {item.badgeValue ? (
                        <Badges color="primary" className="pull-right">
                          {item.type}
                        </Badges>
                      ) : (
                        <span className="pull-right">{item.type}</span>
                      )}
                    </H6>
                    <P className="mt-0">
                      {item.job_area} <span>{item.job_city}</span>
                      <span>
                        <Rating className="ms-1" fillColor={"#FFAE1A"} initialValue={Math.random() * 5} size={16} />
                      </span>
                    </P>
                  </div>
                </div>
                <P>{item.job_description}</P>
              </CardBody>
            </div>
          </Card>
        </div>
      ))}
      {!pagination && <PaginationCard />}
    </>
  );
};
export default RightSidebarCards;
